import {
  deleteLabelsId,
  getGetLabelsQueryKey,
  postLabels,
  putLabelsId,
} from '@ipfabric/api-client/client/model/labels/labels';
import type {
  GetLabels200Item,
  PostLabelsBody,
  PutLabelsIdBody,
} from '@ipfabric/api-client/client/schemas';

export type LabelCatalogEntry = GetLabels200Item;
export { getGetLabelsQueryKey };

export type EditableLabel = Pick<LabelCatalogEntry, 'id' | 'name' | 'values'>;

export const createLabel = (body: PostLabelsBody) => postLabels(body);

export const updateLabel = (id: string, body: PutLabelsIdBody) =>
  putLabelsId(id, body);

export const deleteLabels = (ids: string[]) =>
  Promise.all(ids.map((id) => deleteLabelsId(id)));
